import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge doit connaître les tailles, rayons, ombres et animations
 * propres au thème (index.css). Sans ça, `text-ui` serait pris pour une
 * couleur et `cn("text-ui text-muted-foreground")` en supprimerait un.
 */
export const twMergeConfig = {
  extend: {
    theme: {
      text: ["2xs", "caption", "ui"],
      radius: ["card", "panel", "sheet"],
      shadow: ["card", "raised", "menu", "pop", "paper", "knob"],
      animate: ["fade-in", "slide-in-right", "slide-down", "pop-in", "shimmer"],
    },
  },
};

const twMerge = extendTailwindMerge(twMergeConfig);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
